import TrainingPage from "../../modules/training/views/page.vue";
import { PermissionList } from "../../static-data/PermissionList";
import RouterViewRender from "../../utils/routes/router-view-render";
import { IsAbleNavigation } from "../utils/is-able-navigation";

const TrainingPageRoutes = {
  path: "pagina-treinamento",
  component: RouterViewRender,
  beforeEnter: (to, from, next) =>
    IsAbleNavigation(to, from, next, PermissionList.INSTITUTIONAL_PAGE_MENU),
  children: [
    {
      path: "",
      component: TrainingPage,
      meta: {
        requiresAuth: true,
      },
    },
  ],
};

export default TrainingPageRoutes;
